import SafeSvg from "../../components/SafeSvg"
import { Icon } from "./primitives"

export default function CertIcon({ cert, size = 22 }) {
    if (cert.logoUrl) {
        return <img src={cert.logoUrl} alt="" className="cert-icon__img" style={{ width: size, height: size }} />
    }
    if (cert.svg) {
        return <SafeSvg svg={cert.svg} className="cert-icon__svg" style={{ width: size, height: size }} />
    }
    return <Icon name={cert.icon || "ribbon-star"} size={size} />
}
